var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlugIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "30px",
    width: "30px",
    id: "XMLID_232_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "action"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.7,23.7l-1.4-1.4l2.4-2.4c-2.4-2.8-2.2-7,0.4-9.6l1.7-1.7l10.7,10.7l-1.6,1.6c-1.4,1.4-3.2,2.1-5.1,2.1 c-1.7,0-3.3-0.6-4.6-1.7L1.7,23.7z M5,19.4c1,1,2.3,1.5,3.7,1.5s2.7-0.5,3.7-1.5l0.2-0.2l-7.8-7.9l-0.3,0.3c-2,2-2,5.2,0,7.2 L5,19.4z M19.2,15.3l-2.5-2.5l-2.3,2.3L13,13.8l2.3-2.3l-2.8-2.8L10.2,11L8.8,9.6l2.3-2.3L8.6,4.8l1.6-1.6 c1.4-1.4,3.2-2.1,5.1-2.1c1.7,0,3.3,0.6,4.6,1.7l2.4-2.4l1.4,1.4l-2.4,2.4c2.4,2.8,2.2,7-0.4,9.6L19.2,15.3z M11.4,4.6l7.8,7.9 l0.3-0.3c2-2,2-5.2,0-7.2L19,4.4c-1-1-2.3-1.5-3.7-1.5s-2.7,0.5-3.7,1.5L11.4,4.6z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIn);
export default __webpack_public_path__ + "static/media/plug_in.399f1f416877a479ea7c4d8faa92df64.svg";
export { ForwardRef as ReactComponent };